import * as tslib_1 from "tslib";
import { FileSyncServiceBase } from '../../sync/file-sync.service.base';
import { SettingsService } from '../../sync/settings.service';
import { BaseLayoutComponent } from './base-layout.component';
var CupcinoLayoutComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CupcinoLayoutComponent, _super);
    function CupcinoLayoutComponent(settings, fileSync) {
        var _this = _super.call(this, settings, fileSync) || this;
        _this.imageRight$ = _this.getLayoutImage$('image_right');
        _this.imageBottom$ = _this.getLayoutImage$('image_bottom');
        return _this;
    }
    return CupcinoLayoutComponent;
}(BaseLayoutComponent));
export { CupcinoLayoutComponent };
